import React, { useRef, useState } from 'react';
import { Upload, Paperclip, X } from 'lucide-react';
import AuthImage, { openAuthUrl } from '../AuthImage';

export default function AttachmentsSection({ task, canManage, onUploadFile, onAddLink, onDelete, uploading }) {
  const fileRef = useRef(null);
  const [showAtt, setShowAtt] = useState(false);
  const [attName, setAttName] = useState('');
  const [attUrl, setAttUrl] = useState('');

  const submitLink = async () => {
    if (!attName || !attUrl) return;
    const ok = await onAddLink(attName, attUrl);
    if (ok) { setAttName(''); setAttUrl(''); setShowAtt(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="tm-label">Attachments</div>
        <div className="flex gap-1">
          {canManage && (
            <>
              <button className="tm-btn-ghost" onClick={() => fileRef.current?.click()} title="Upload file" data-testid="att-upload-btn" disabled={uploading}>
                <Upload size={14} />{uploading ? '…' : ''}
              </button>
              <input ref={fileRef} type="file" style={{ display: 'none' }} data-testid="att-file-input"
                onChange={(e) => e.target.files?.[0] && onUploadFile(e.target.files[0])} />
              <button className="tm-btn-ghost" onClick={() => setShowAtt(!showAtt)} data-testid="att-toggle" title="Add link"><Paperclip size={14} /></button>
            </>
          )}
        </div>
      </div>
      <div className="space-y-1">
        {(task.attachments || []).map((a) => {
          const isImg = a.mime_type?.startsWith('image/');
          const isInternal = a.url.startsWith('/api/');
          return (
            <div key={a.id} className="flex items-center gap-2 p-1" data-testid={`att-${a.id}`}>
              {isImg
                ? <AuthImage url={a.url} alt={a.name} style={{ width: 40, height: 30, objectFit: 'cover', borderRadius: 3, cursor: 'pointer' }} onClick={() => openAuthUrl(a.url, a.name)} />
                : <Paperclip size={14} />}
              {isInternal ? (
                <a href='#' onClick={(e) => { e.preventDefault(); openAuthUrl(a.url, a.name); }} style={{ flex: 1, fontSize: 13, color: 'var(--trello-blue)', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {a.name} {a.size_bytes ? <span style={{ color: 'var(--trello-text-muted)' }}>({Math.round(a.size_bytes / 1024)} KB)</span> : null}
                </a>
              ) : (
                <a href={a.url} target="_blank" rel="noreferrer" style={{ flex: 1, fontSize: 13, color: 'var(--trello-blue)', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {a.name}
                </a>
              )}
              {canManage && <button className="tm-btn-ghost" style={{ padding: 2 }} onClick={() => onDelete(a)}><X size={12} /></button>}
            </div>
          );
        })}
        {(task.attachments || []).length === 0 && <div style={{ fontSize: 13, color: 'var(--trello-text-muted)' }}>None yet</div>}
      </div>
      {showAtt && (
        <div className="mt-2 space-y-2">
          <input className="tm-input" placeholder="Name (e.g., Design brief)" value={attName} onChange={(e) => setAttName(e.target.value)} data-testid="att-name" />
          <input className="tm-input" placeholder="URL (https://…)" value={attUrl} onChange={(e) => setAttUrl(e.target.value)} data-testid="att-url" />
          <button className="tm-btn" onClick={submitLink} data-testid="att-save">Add link</button>
        </div>
      )}
    </div>
  );
}
